var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReturnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.875071 6.99917C1.31787 6.99917 1.67725 7.33171 1.74142 7.76926C2.11539 10.3006 4.30198 12.2498 6.93546 12.2498C10.1302 12.2498 12.6686 9.3812 12.1085 6.08381C11.8442 4.52904 10.8553 3.15338 9.46976 2.40079C7.42435 1.29057 5.10591 1.66978 3.53072 3.01044L4.18996 3.66969C4.55751 4.03723 4.29731 4.66556 3.7775 4.66556H1.10201C0.779977 4.66556 0.518612 4.40419 0.518612 4.08215V1.40667C0.518612 0.886858 1.14694 0.62666 1.51448 0.994204L2.29157 1.7713C4.36907 -0.068756 7.47335 -0.624739 10.2247 0.819766C12.1616 1.83664 13.5291 3.75253 13.8552 5.91579C14.5098 10.2546 11.1523 14 6.93604 14C3.42337 14 0.506361 11.3998 0.00988504 8.02246C-0.0688743 7.48573 0.332507 6.99917 0.875071 6.99917Z",
    fill: "#030304"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnIcon);
export default __webpack_public_path__ + "static/media/return-icon.b813f02fa8129556c63751bd14e07572.svg";
export { ForwardRef as ReactComponent };